const SUCCESS_TOAST_DURATION_MS = 4000;
const DEFAULT_TOAST_DURATION_MS = 8000;

export function getToastDurationMs(message: {
  type?: "success" | "error" | "info" | "warning";
  durationMs?: number;
}): number {
  if (message.durationMs != null && message.durationMs > 0) {
    return message.durationMs;
  }
  if (message.type === "success") return SUCCESS_TOAST_DURATION_MS;
  return DEFAULT_TOAST_DURATION_MS;
}

export function getRemainingToastMs(
  remainingMs: number,
  elapsedMs: number
): number {
  return Math.max(0, remainingMs - elapsedMs);
}
